<template>
    <div class="enter-cabinet__choose enter-cabinet-choose">
        <span
            :class="{'active' : chooseEnter === 'phone'}"
            @click="setEnter('phone')"
        >
            {{ messages.phone }}
        </span>
        <span
            :class="{'active' : chooseEnter === 'email'}"
            @click="setEnter('email')"
        >
            {{ messages.email }}
        </span>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: 'enter-cabinet-choose',
    selector: '.enter-cabinet-choose',
    computed: {
        ...mapState({
            chooseEnter: ({ personal }) => personal.data.chooseEnter,
            messages: ({ personal }) => personal.data.messages,
        })
    },
    methods: {
        ...mapMutations({
            setEnter: 'personal/setEnter',
        }),
    }
}
</script>

<style lang="scss" scoped>
.enter-cabinet-choose{
    margin-top: 24px;
}
</style>